module.exports = __webpack_public_path__ + "static/media/good_chilling_vibe.62ec26ac.mp3";